// pi-v2-info-applicant.component.ts
import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { DeveloperProject } from '@app/interfaces';

@Component({
  selector: 'mnf-pi-v2-info-applicant',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './pi-v2-info-applicant.component.html',
  styleUrls: ['./pi-v2-info-applicant.component.scss']
})
export class PiV2InfoApplicantComponent {
  @Input() developer: DeveloperProject;

  public readonly urlBaseS3 = 'https://static.monific.com/assets/applicants/';

  constructor() { }

  /**
   * Builds the logo URL, or returns null if logo or company is invalid.
   * Avoids querying static.monific when values are null, 'null', 'undefined', or undefined.
   */
  getLogoUrl(logo: string | null | undefined): string | null {
    const company = this.developer?.company;
    // guard against invalid logo or company values
    if (!logo || logo === 'null' || logo === 'undefined' || !company || company === 'null' || company === 'undefined') {
      return null;
    }

    const baseUrl = 'https://static.monific.com/assets';
    // if full URL provided, return as is
    if (logo.startsWith('https://')) {
      return logo;
    }

    // otherwise, build URL from S3 base
    return `${this.urlBaseS3}${company}/${logo}`;
  }
}
